import React, { useState, useEffect } from 'react';
import WatchWinding from './WatchWinding';
import { soundManager } from '../../utils/soundManager';
import './LoadingScreen.css';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (progress >= 100 && !isComplete) {
      setIsComplete(true);
      
      // Play completion sound
      soundManager.play('whoosh', 0.4);
      
      // Wait for exit animation before calling onComplete
      setTimeout(() => {
        onComplete();
      }, 1500);
    }
  }, [progress, isComplete, onComplete]);

  const handleProgressUpdate = (newProgress) => {
    setProgress(newProgress);
  };

  return (
    <div className={`loading-screen ${isComplete ? 'complete' : ''}`}>
      {/* Subtle background gradient */}
      <div className="loading-background"></div>

      {/* Main content */}
      <div className="loading-content">
        {/* Brand logo */}
        <div className="loading-logo">
          <span className="logo-diamond">◆</span>
          <h1 className="logo-text">CHRONOS</h1>
          <p className="logo-tagline">Time Perfected</p>
        </div>

        {/* Watch winding mechanism */}
        <WatchWinding 
          progress={progress} 
          onProgressUpdate={handleProgressUpdate}
        />

        {/* Instruction text */}
        <div className="loading-instruction">
          {progress < 100 ? (
            <>
              <p className="instruction-text">Preparing Your Journey</p>
              <p className="instruction-subtext">Precision in Progress</p>
            </>
          ) : (
            <p className="instruction-text complete-text">Welcome</p>
          )}
        </div>

        {/* Progress indicator */}
        <div className="loading-progress">
          <span className="progress-number">{Math.floor(progress)}%</span>
        </div>
      </div>

      {/* Bottom signature */}
      <div className="loading-footer">
        <p>Swiss Craftsmanship Since 1873</p>
      </div>
    </div>
  );
};

export default LoadingScreen;